export default __webpack_public_path__ + "static/media/hero.7b9b059c.svg";